import {
  SIGNALS_REQUEST,
  FETCH_ANOMALY_RULE_SUCCESS,
  FETCH_ANOMALY_RULE_FAILURE,
  FETCH_ANOMALY_TYPE_FAILURE,
  FETCH_ANOMALY_TYPE_SUCCESS,
  FETCH_SIGNALS_SUCCESS,
  FETCH_SIGNALS_FAILURE,
  ANOMALY_RULE_REQUEST,
  CLEAR_ANOMALY_STATE,
  CLEAR_ANOMALY_RULE,
  CLEAR_CURRENT_SIGNALS,
  CLEAR_ANOMALY_SEARCH_FILTERS,
  CREATE_ANOMALY_RULE_SUCCESS,
  CREATE_ANOMALY_RULE_FAILURE,
  DELETE_ANOMALY_RULE_SUCCESS,
  DELETE_ANOMALY_RULE_FAILURE,
  PERSIST_ANOMALY_RULE_FILTER,
  DELETED_ANOMALY_RULE_ID,
  SET_TYPE_FILTERS,
  CLEAR_TYPE_FILTERS,
} from "../_constants";

const initialState = {
  signalsLoading:false,
  loading: false,
  anomalyType: "",
  anomalyRule: "",
  signals: "",
  error: "",
  scopedAnomalyCreated: false,
  createError: "",
  scopedAnomalyRule: "",
  selectedEntities: "",
  ruleId: "",
  anomalyRuleFilter: "",
  deletedAnomalyRule:"",
  anomalyRequestloading: false,
  typeFilters:''
};

export const anomalyRuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ANOMALY_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        anomalyRule: "",
      };

    case FETCH_SIGNALS_SUCCESS:
      return {
        ...state,
        signals: action.payload,
        error: "",
        signalsLoading:false,
      };
    case SET_TYPE_FILTERS:
      return {
        ...state,
        typeFilters:action.payload
      };
    case CLEAR_TYPE_FILTERS:
      return {
        ...state,
        typeFilters:""
      };
    case SIGNALS_REQUEST:
      return {
        ...state,
        signals: '',
        signalsLoading:true,
      };
    case FETCH_SIGNALS_FAILURE:
      return {
        ...state,
        signals: "",
        error: action.payload,
      };
    case FETCH_ANOMALY_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        anomalyRule: action.payload,
        error: "",
        anomalyRequestloading: false
      };
    case FETCH_ANOMALY_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        anomalyRule: "",
        error: action.payload,
        anomalyRequestloading: false
      };
    case CREATE_ANOMALY_RULE_SUCCESS: {
      return {
        ...state,
        ruleId: action.payload,
        error: "",
      };
    }
    case CREATE_ANOMALY_RULE_FAILURE: {
      return {
        ...state,
        ruleId: "",
        createError: action.payload,
      };
    }
    case DELETE_ANOMALY_RULE_SUCCESS: {
      return {
        ...state,
        error: "",
      };
    }
    case DELETE_ANOMALY_RULE_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case FETCH_ANOMALY_TYPE_SUCCESS:
      return {
        ...state,
        anomalyType: action.payload,
        error: "",
      };
    case FETCH_ANOMALY_TYPE_FAILURE:
      return {
        ...state,
        anomalyType: "",
        error: action.payload,
      };

    case PERSIST_ANOMALY_RULE_FILTER:
      return {
        ...state,
        anomalyRuleFilter: action.payload,
      };
    case CLEAR_ANOMALY_STATE:
      return {
        ...state,
        error: "",
        createError: ""
      };
    case CLEAR_ANOMALY_RULE:
      return {
        ...state,
        anomalyRule:""
      };
    case DELETED_ANOMALY_RULE_ID:
      return{
        ...state,
        error:'',
        deletedAnomalyRule: action.payload
      };
      case CLEAR_ANOMALY_SEARCH_FILTERS:
      return {
        ...state,
        typeFilters: ""
      };
      case CLEAR_CURRENT_SIGNALS:
      return {
        ...state,
        anomalyRule: "",
        anomalyRuleFilter: "",
        signals: ""
      };

    default:
      return state;
  }
};
